<p-card styleClass="h-full">
  <div class="flex align-items-center gap-2 mb-4">
    <i class="pi pi-sliders-h text-xl"></i>
    <h2 class="m-0">Paramètres Tablot</h2>
  </div>

  @if (loading) {
    <div class="flex justify-content-center align-items-center py-6">
      <p-progressSpinner
        strokeWidth="4"
        [style]="{ width: '48px', height: '48px' }"
      />
    </div>
  } @else if (settings.length === 0) {
    <div
      class="flex flex-column align-items-center py-6 gap-2 text-color-secondary"
    >
      <i class="pi pi-info-circle text-3xl"></i>
      <p class="m-0">
        Aucun paramètre Tablot trouvé en base de données.<br />
        Exécutez le seeder <code>TablotSettingsSeeder</code> pour les
        initialiser.
      </p>
    </div>
  } @else {
    <form [formGroup]="form" (ngSubmit)="saveAll()">
      <div class="grid">
        @for (setting of settings; track setting.id) {
          <div class="col-12 md:col-6 xl:col-4">
            <div class="setting-card border-round p-3 h-full">
              <div class="flex align-items-center gap-2 mb-2">
                <i
                  [class]="getMeta(setting.key).icon + ' text-primary text-lg'"
                ></i>
                <span class="font-semibold text-sm">{{
                  getMeta(setting.key).label
                }}</span>
              </div>
              <p class="text-xs text-color-secondary mt-0 mb-3 line-height-3">
                {{ setting.description }}
              </p>
              <div class="flex align-items-center gap-2">
                <p-inputNumber
                  [formControlName]="setting.key"
                  [min]="getMeta(setting.key).min"
                  [max]="getMeta(setting.key).max"
                  [useGrouping]="false"
                  inputStyleClass="w-full"
                  styleClass="w-full"
                  [suffix]="' ' + getMeta(setting.key).unit"
                />
              </div>
            </div>
          </div>
        }
      </div>

      <div
        class="flex justify-content-end align-items-center gap-3 mt-4 pt-3 border-top-1 surface-border"
      >
        <button
          pButton
          type="button"
          label="Réinitialiser"
          icon="pi pi-refresh"
          class="p-button-outlined p-button-secondary"
          [disabled]="!isDirty || saving"
          (click)="resetForm()"
        ></button>
        <button
          pButton
          type="submit"
          label="Sauvegarder"
          icon="pi pi-save"
          [loading]="saving"
          [disabled]="!isDirty || form.invalid"
        ></button>
      </div>
    </form>
  }
</p-card>
